import utils from 'utils'
class inputSynInvoiceCtrl {
    constructor($scope, $timeout, $filter, $uibModalInstance, logger, globalFn, httpRequest) {
        $scope.selectOrgTree = []
        $scope.treeConfig = {
            width: '150%',
            isCheckall: false,
            concatParentChild: true,
            concatParentChildChecked: true,
            check: {
                //如果没有设置配置项，取默认配置
                enable: true, //显示不显示复选框
                chkStyle: 'radio',
                radioType: 'all',
            },
        }
        //若进项设置-发票采集方式为【管理平台】 隐藏非必填项
        $scope.showInput = false
        $scope.modaldata = {
            collection: 1, //查询类型枚举 查询类型 默认1 ,
            electricInvoiceNum: '', //全电发票号码
            invoiceCode: '', //增值发票代码
            invoiceNumber: '', //增值发票号码
            invoiceDateStart: '', //开票日期 起 yyyy-MM-dd
            invoiceDateEnd: '', //开票日期 止 yyyy-MM-dd
            invoiceSource: '0', //发票来源
            invoiceStatus: '', //发票状态代码
            invoiceType: '', //发票种类
            orgId: $scope.userInfo.org.orgId, //机构id
            otherSideName: '', //对方纳税人名称
            otherSideTaxNo: '', //对方纳税人识别号
        }
        $scope.getCurrentSelectOrgInfo = function () {
            httpRequest
                .get_getOrgIdSaleInfo({ orgId: Number($scope.modaldata.orgId) })
                .then((res) => {
                    let diskType = res.data.ivatCollectServer.diskType
                    if (diskType === '3') {
                        $scope.showInput = false
                        $scope.modaldata.manageType = '3'
                        $scope.modaldata.creditCode = res.data.saleCreditCode
                    } else {
                        $scope.showInput = true
                        $scope.modaldata.manageType = ''
                        $scope.modaldata.creditCode = ''
                    }
                })
        }
        $scope.getCurrentSelectOrgInfo()
        // httpRequest.get_getUserSaleInfo().then((res) => {
        //     let diskType = res.data.value.ivatCollectServer.diskType
        //     if (diskType === '3') {
        //         $scope.showInput = false
        //     } else {
        //         $scope.showInput = true
        //     }
        // })
        const dictTypeArr = ['pool_inv_type', 'red_confirm_invoice_source']
        httpRequest.get_dictByTypeArr(JSON.stringify(dictTypeArr)).then((res) => {
            $scope.dictData = $.extend($scope.dictData, res.data.value)
            $scope.dictData.invoice_status = [
                {
                    enumCode: '1',
                    enumName: '正常',
                },
                {
                    enumCode: '2',
                    enumName: '已作废',
                },
                {
                    enumCode: '3',
                    enumName: '全部红冲',
                },
                {
                    enumCode: '4',
                    enumName: '部分红冲',
                },
            ]
        })
        httpRequest.get_getUserOrgList().then((res) => {
            $scope.orgList = res.data.value
        })
        let timeSpan = 365
        $timeout(() => {
            const nowDate = new Date()
            const initStartDate = $scope.isTaxUkey
                ? globalFn.addDate(nowDate, -9)
                : $filter('date')(nowDate, 'yyyy-MM-01')
            const initEndDate = $filter('date')(nowDate, 'yyyy-MM-dd')
            // var _initEndDate = globalFn.addDate(initStartDate,31);
            $('#datetimeStart1').val(initStartDate)
            $('#datetimeEnd1').val(initEndDate)
            $('#datetimeStart1')
                .datetimepicker({
                    autoclose: true,
                    minView: 'month', // 选择日期后，不会再跳转去选择时分秒
                    language: 'zh-CN',
                    format: 'yyyy-mm-dd',
                    forceParse: 0,
                    pickTime: false,
                    pickerPosition: 'bottom-right',
                    // startDate:"2017-01-01",
                    // initialDate:now
                })
                .on('changeDate', (e) => {
                    const dateText = e.date
                    let endDate = globalFn.addDate(dateText, timeSpan)
                    endDate =
                        globalFn.getTime2Time(initEndDate, endDate) >= 0 ? endDate : initEndDate
                    $scope.modaldata.invoiceDateStart = e.target.value
                    if (
                        globalFn.getTime2Time(
                            $scope.modaldata.invoiceDateEnd,
                            $scope.modaldata.invoiceDateStart
                        ) > timeSpan
                    ) {
                        // $('#datetimeEnd1').datetimepicker('setEndDate', endDate);
                        $scope.modaldata.invoiceDateEnd = endDate
                        $('#datetimeEnd1').val(endDate)
                    }
                    // setStartDate setEndDate
                    $('#datetimeEnd1').datetimepicker('setStartDate', dateText)
                    $('#datetimeStart1').datetimepicker(
                        'setEndDate',
                        $scope.modaldata.invoiceDateEnd
                    )
                })
            $('#datetimeEnd1')
                .datetimepicker({
                    autoclose: true,
                    minView: 'month', // 选择日期后，不会再跳转去选择时分秒
                    language: 'zh-CN',
                    format: 'yyyy-mm-dd',
                    forceParse: 0,
                    pickTime: false,
                    pickerPosition: 'bottom-right',
                    // startDate:"2017-01-01",
                    // initialDate:now
                })
                .on('changeDate', (e) => {
                    const dateText = e.date
                    const startDate = globalFn.addDate(dateText, -1 * timeSpan)
                    $scope.modaldata.invoiceDateEnd = e.target.value
                    if (
                        globalFn.getTime2Time(
                            $scope.modaldata.invoiceDateEnd,
                            $scope.modaldata.invoiceDateStart
                        ) > timeSpan
                    ) {
                        $scope.modaldata.invoiceDateStart = startDate
                        $('#datetimeStart1').val(startDate)
                        // $('#datetimeStart1').datetimepicker('setStartDate', startDate);
                    }
                    $('#datetimeStart1').datetimepicker('setEndDate', dateText)
                    $('#datetimeEnd1').datetimepicker(
                        'setStartDate',
                        $scope.modaldata.invoiceDateStart
                    )
                })
            $scope.modaldata.invoiceDateStart = initStartDate
            $scope.modaldata.invoiceDateEnd = initEndDate
            $('#datetimeStart1').datetimepicker('setEndDate', initEndDate)
            $('#datetimeEnd1').datetimepicker('setStartDate', initStartDate)
            $('#datetimeEnd1').datetimepicker('setEndDate', initEndDate)
        }, 500)

        $scope.datetimeStartChange = function (e) {
            $scope.modaldata.invoiceDateStart = e.currentTarget.value
        }
        $scope.datetimeEndChange = function (e) {
            $scope.modaldata.invoiceDateEnd = e.currentTarget.value
        }

        // 关闭
        $scope.cancel = function () {
            $uibModalInstance.dismiss('cancel')
        }
        // 确定
        $scope.ok = function (v) {
            $scope.modaldata.invoiceStatusList = []
            $scope.modaldata.invoiceTypeList = []
            if ($scope.modaldata.invoiceStatus)
                $scope.modaldata.invoiceStatusList.push($scope.modaldata.invoiceStatus)
            if ($scope.modaldata.invoiceType)
                $scope.modaldata.invoiceTypeList.push($scope.modaldata.invoiceType)
            const days = utils.DateMinus(
                $scope.modaldata.invoiceDateStart,
                $scope.modaldata.invoiceDateEnd
            )
            if (!$scope.selectOrgTree.length) return logger.logError('请选择机构')
            if (days > 31) {
                logger.logError('开票日期查询跨度不允许超过30天')
                return
            }
            $scope.modaldata.orgId = $scope.selectOrgTree[0].orgId
            $uibModalInstance.close($scope.modaldata)
        }
    }
}

inputSynInvoiceCtrl.$inject = [
    '$scope',
    '$timeout',
    '$filter',
    '$uibModalInstance',
    'logger',
    'globalFn',
    'httpRequest',
]
export default inputSynInvoiceCtrl



// WEBPACK FOOTER //
// ./src/app/input/invoicePool/inputInvoicePool/synInvoiceCtrl.js